import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import PaymentPage from './pages/payment/PaymentPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import SenderPage from './pages/sender/SenderPage';

// Componente para proteger rotas que precisam de autenticação
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Carregando...</div>;
  }
  
  if (!user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// Componente para proteger rotas que precisam de pagamento
const PaymentProtectedRoute = ({ children }) => {
  const { user, paymentApproved, loading } = useAuth();
  
  if (loading) {
    return <div>Carregando...</div>;
  }
  
  if (!user) {
    return <Navigate to="/" replace />;
  }
  
  if (!paymentApproved) {
    return <Navigate to="/payment" replace />;
  }
  
  return children;
};

// Componente para redirecionar usuários autenticados da página de login
const PublicRoute = ({ children }) => {
  const { user, paymentApproved, loading } = useAuth();
  
  if (loading) {
    return <div>Carregando...</div>;
  }
  
  if (user) {
    if (paymentApproved) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/payment" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } 
        />
        <Route path="/cadastro" element={<RegisterPage />} />
        <Route 
          path="/payment" 
          element={
            <PrivateRoute>
              <PaymentPage />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/dashboard" 
          element={
            <PaymentProtectedRoute>
              <DashboardPage />
            </PaymentProtectedRoute>
          } 
        />
        <Route 
          path="/sender" 
          element={
            <PaymentProtectedRoute>
              <SenderPage />
            </PaymentProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
